import { useState } from "react";
import { subscribe } from "@/lib/api";
import { PrimaryButton, Overline } from "./Primitives";
import { toast } from "sonner";

export const NewsletterSection = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      const res = await subscribe({ email });
      setDone(true);
      toast.success(res.message || "Welcome to the cottage.");
    } catch (err) {
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-brand-sage/25 paper-texture" data-testid="newsletter-section">
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32 text-center">
        <Overline>Letters from the Cottage</Overline>
        <h2 className="text-4xl sm:text-5xl font-light mt-4 mb-5">Join the Cottage Newsletter</h2>
        <p className="font-body text-brand-body text-lg leading-relaxed max-w-xl mx-auto mb-10">
          Once a fortnight I write a quiet letter — a seasonal recipe, a herbal remedy, a small thought
          for a slower life. No noise, no selling. Only warmth.
        </p>
        {done ? (
          <p className="font-serif text-2xl text-brand-olive" data-testid="newsletter-success">
            The kettle is on. Do watch your inbox for my first letter.
          </p>
        ) : (
          <form onSubmit={submit} className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto">
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your@email.com"
              data-testid="newsletter-email-input"
              className="flex-1 bg-brand-warm-white border border-brand-linen px-5 py-4 font-body text-brand-charcoal focus:outline-none focus:border-brand-gold transition-colors"
            />
            <PrimaryButton type="submit" testid="newsletter-submit-btn" disabled={loading}>
              {loading ? "…" : "Subscribe"}
            </PrimaryButton>
          </form>
        )}
      </div>
    </section>
  );
};
